import * as d3 from 'd3-selection'
import yPos from './y-text-position.js'
import * as colors from 'scoreboard-colors'

const height = 10
    , cornerRadius = 2
    // use this much of the extra space for bottom padding
    , verticalOffsetPercentage = 0.75

export default function (dimensions) {
  var draw = function (selection) {
    selection.each(function (d) {
      const color = d.value && d.value.color || (colors.lookup('gray').color)
      const variation = colors.getTextVariation(color)

      var explanation = d3.select(this)
                           .selectAll('g.explanation').data(function (d) {
                             return d.explanation ? [d] : []
                           })


      var enter = explanation.enter()
                             .append('g')
                               .attr('class', 'explanation')

      enter.append('rect')
      enter.append('g')
           .attr('class', 'text-group-explanation')
           .append('text')
           .attr('class', 'label-on-colored-background')

      var _explanation = enter.merge(explanation)
        , topOffset = (dimensions.header.height - height) * verticalOffsetPercentage

      _explanation.attr('transform', 'translate(' + dimensions.padding.left + ',' + (dimensions.viewbox.height + topOffset) + ')')
                  .attr('class', 'explanation')

      _explanation.select('rect')
                  .attr('width', dimensions.width)
                  .attr('height', height)
                  .attr('rx', cornerRadius)
                  .attr('ry', cornerRadius)
                  .style('fill', color)

      _explanation.select('g.text-group-explanation')
                  .attr('transform', `translate(${dimensions.width / 2},0)`)
      _explanation.select('text')
                  .text(function (d) {
                    return d.explanation
                  })
                  .classed('light', variation === 'light')
                  .classed('dark', variation === 'dark')
                  .style('font-size', function () {
                    return Math.min(6, (dimensions.width - 8) / this.getComputedTextLength() * 15) + 'px'
                  })
                  .attr('y', function (d) {
                    return yPos(parseFloat(d3.select(this).style('font-size')), height)
                  })

      explanation.exit().remove()
    })
  }

  return draw
}
